// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H10V10H14V5H22V22H13V15H11V22H2V2ZM4 20H6V10H8V4H4V20ZM16 10H18V20H20V7H16V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-12-filled')
export default class City12FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-12-filled',
    }
  }
}
